import { createFileRoute } from '@tanstack/react-router'

import { CoreSkillsAssessmentStepResultsFinal } from '@/core-skills-assessment/components/CoreSkillsAssessmentStepResultsFinal/CoreSkillsAssessmentStepResultsFinal'

export const Route = createFileRoute('/skills-assessment/results-final')({
  component: CoreSkillsAssessmentStepResultsFinal,
})
